import { useState, MouseEventHandler } from 'react';

import AttachmentIcon from '@mui/icons-material/Attachment';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, ListItemIcon, Menu, MenuItem, Stack } from '@mui/material';

import { ImageSelector } from 'components/organisms/PageEditor/editorControls/ImageSelector';

type MarkerImageSelectorProps = {
    value?: string;
    disabled?: boolean;
    onChange?: (link?: string) => void;
    onClose?: () => void;
};

export const MarkerImageSelector = ({
    value,
    disabled,
    onClose = () => undefined,
    onChange = () => undefined,
}: MarkerImageSelectorProps): JSX.Element => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);

    const handleMenuClick: MouseEventHandler<HTMLLIElement> = (e) => {
        setAnchorEl(e.currentTarget);
    };
    const handleClose = (): void => {
        setAnchorEl(null);
        onClose();
    };

    return (
        <div>
            <MenuItem
                onClick={(e) => {
                    handleMenuClick(e);
                }}
                selected={open}
                disabled={disabled}
            >
                <ListItemIcon sx={{ mx: -1 }}>
                    <AttachmentIcon />
                </ListItemIcon>
                Изображение
                <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center' }}>
                    <ChevronRightIcon sx={{ mr: -2, ml: 2 }} color="action" />
                </Box>
            </MenuItem>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={() => {
                    handleClose();
                }}
                anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                PaperProps={{
                    sx: {
                        p: 1,
                    },
                }}
            >
                <Stack sx={{ minWidth: 300 }}>
                    <ImageSelector
                        defaultSelectedUuid={value}
                        onSelect={(img) => onChange(img.uuid)}
                    />
                </Stack>
            </Menu>
        </div>
    );
};
